import { N as NcActionButton } from "./chunks/NcActionButton-BFxArTsE.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-B5OcRwWQ.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-DSMKeccY.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-DXiL7Phe.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-yAm71xxU.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-C_H0APKA.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-BYqqHPj2.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-DiOscHZ8.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-DD1CfV7A.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-8NN7iPkz.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-B50v2lmS.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-B7_0fFTF.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-ChGonQL8.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-9nG2gY_9.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-C2rBRxUv.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-19hVcGhv.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-DwORvUjC.mjs";
import { u } from "./chunks/NcAvatar-DwORvUjC.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-do2wxY-0.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-DPF3ELzz.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-CL_IHuT9.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-BaMf0PDd.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-iHUm6owG.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-av-NHSU7.mjs";
import { N as NcContent } from "./chunks/NcContent-uiwRXAwA.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-CDfRYl8B.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-DDaM0QjK.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-C44gZwCP.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-BfJVNppR.mjs";
import { u as u2 } from "./chunks/NcDateTime-BfJVNppR.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-D3Z5tp_6.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-BhPydgMe.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-C5HYxVqp.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import NcHeaderButton from "./Components/NcHeaderButton.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Bc1ucNsv.mjs";
import { N as NcHighlight } from "./chunks/index-Bz6q9mZw.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-CHmdAuhg.mjs";
import { N as NcInputField } from "./chunks/NcInputField-DTtUueUZ.mjs";
import { N as NcListItem } from "./chunks/NcListItem-CA4CzIW8.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-DhENqcJ-.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-zMKko5oa.mjs";
import { N as NcPopover } from "./chunks/NcPopover-C9KlPo4Z.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-DegJ2JjE.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-BxBE_1N3.mjs";
import { N as NcMentionBubble } from "./chunks/index-G8WQDZ8G.mjs";
import { r } from "./chunks/index-G8WQDZ8G.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-Ct8cG0U6.mjs";
import { N as NcRichText } from "./chunks/NcRichText-h1RHm2bK.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-56SXuvlv.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-DTLuXI-A.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
import "@nextcloud/sharing/public";
import "@nextcloud/auth";
import { N as NcSelect } from "./chunks/NcSelect-DrtYueu1.mjs";
import { N as NcTextField } from "./chunks/NcTextField-DpLIIKYI.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-nv1147dk.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags--4zU4C41.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-DKscbkn_.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-DP3xDXrA.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-DHuru8HO.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-BHERsE_g.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-CGuLj6Bs.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-X7NIiLjg.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-D1Mw6nKB.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-BY_D0V5K.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { u as u3 } from "./chunks/usernameToColor-DLOoqQAF.mjs";
import { directive } from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  spawnDialog,
  u2 as useFormatDateTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  u3 as usernameToColor
};
//# sourceMappingURL=index.mjs.map
